import React from "react";
import { useCart } from "../context/CartContext";
import { useNavigate, useLocation } from "react-router-dom";

export default function FloatingCheckoutButton() {
  const { totalItems, closeCart } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === "/checkout") return null;
  if (totalItems === 0) return null;

  return (
    <div
      className="
        fixed bottom-0 left-0 w-full z-[9999]
        flex justify-center 
        pb-4 pointer-events-none
      "
    >
      <button
        onClick={() => {
                        closeCart();
                        navigate("/checkout")
        }}
        className="
          pointer-events-auto
          rounded-full shadow-[0_-4px_20px_rgba(0,0,0,0.25)]
          flex items-center justify-center gap-3 transition
          bg-black text-white hover:bg-[#d24e1e]

          /* 🟧 Móvil: más estrecho y elegante */
          w-[60%] py-3 text-base font-semibold

          /* 🟦 Desktop: tamaño normal grande */
          sm:w-[420px] sm:py-4 sm:text-lg sm:font-bold
        "
      >
        <span>FINALIZAR COMPRA</span>

        <span
          className="
            bg-white text-black 
            flex items-center justify-center 
            rounded-full font-bold
            w-7 h-7 text-sm
          "
        >
          {totalItems}
        </span>
      </button>
    </div>
  );
}
